import React, { useEffect, useState } from "react";
import { Layout, FormParser,PopupModal } from "../Components";
import { NavLink,useParams } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"
const ReferenceDomainValueEdit = () => {
    const[Error,SetError]=useState("")
    const [popupType, setpopupType] = useState("");

    const MastersModal=Masters.ReferenceDomainValue
    const formSubmit=(Data)=>{
        axiosConfig.patch(`/masters/referencedomainvalue/${id}/`,Data).then(res=>{
                   console.log(res)
                   setpopupType("success")
        }).catch(error=>{
            console.log(error)
            let ErrorData=[]
            ErrorData.push({
                code:error.response.data.non_field_errors||["null"]
                })
                console.log(ErrorData[0].code)
                if(ErrorData[0].code[0]==="The fields domain, code must make a unique set."){
                    SetError("Code Already Exists")
                }
            setpopupType("error")
        })
      }
    let { id } = useParams();
    const [Data, SetData] = useState([])
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get(`/masters/referencedomainvalue/${id}/`)
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
        }

    }
    useEffect(() => {
        GetData();
    }, [])
    return (
        <>
            <Layout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">Edit Domain {id}</h5>
                    <NavLink to="/dashboard/masters/domains/value" ><button className="btn btn-white">Manage</button></NavLink>
                </div>
                <FormParser modelObject={MastersModal} formData={Data} formSubmit={formSubmit} error={Error}/>
                {popupType != "" &&
                    <PopupModal popupType={popupType} Navigation="/dashboard/masters/domains/value" />
                }
            </Layout>
        </>
    )

}
export {ReferenceDomainValueEdit}